import React, { useState } from 'react';
import ApexCharts from 'react-apexcharts';
import { List, ListItem, ListItemIcon, ListItemText, Typography } from '@material-ui/core';
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';

const GraficaAlcohol = ({ positivos, negativos, textStyle, total, totalPositivos }) => {
    const [color, setColor] = useState("#d91c23");
    function calcularPorcentaje(valor, total) {
        let result = (valor / total) * 100;
        return result.toFixed(0);
    }

    const serie2 = positivos;
    const hollowSize = calcularPorcentaje(negativos, total);
    const hollowSize2 = calcularPorcentaje(positivos, total);
    const colores = ['#1983c4', "#d91c23"];

    const options = {
        chart: {
            height: 100,
            type: "radialBar",
        },
        series: [hollowSize, hollowSize2],
        colors: ['#1983c4', "#d91c23"],
        plotOptions: {
            radialBar: {
                track: {
                    background: "#D9D8D8",
                    strokeWidth: "100%",
                },
                hollow: {
                    margin: 0,
                    size: "40%",
                    background: "transparent",
                },
                dataLabels: {
                    name: {
                        offsetY: 15,
                        show: true,
                        fontSize: "11px",
                    },
                    value: {
                        fontWeight: "bold",
                        offsetY: -15,
                        colors: ['#1983c4', "#d91c23"],
                        fontSize: "25px",
                        show: true,
                        formatter: function (val) {
                            if (val === hollowSize) {
                                const valorFormateado = (Math.floor(val * 10) / 10);
                                if (!isNaN(valorFormateado)) {
                                    setColor(colores[0]);
                                    return valorFormateado.toFixed(0) + '%';
                                }
                            } else {
                                setColor(colores[1]);
                                return serie2.toFixed(0) + "%";
                            }
                        },
                        color: color,
                    },
                    total: {
                        show: true,
                        label: 'Positivos',
                        color: "#d91c23",
                        fontSize: "11px",
                        formatter: function (val) {
                            const valorFormateado = (Math.floor(serie2 * 10) / 10);
                            if (!isNaN(valorFormateado)) {
                                return valorFormateado.toFixed(0) + "%";
                            }
                        },
                    },
                },
            },
        },
        labels: ['Negativos', "Positivos"],
        stroke: {
            lineCap: "round",
            width: 1,
        },
    };


    return (
        <>
            <Typography align="center" style={{ fontWeight: 'bold', fontSize: "26px", textAlign: 'center', marginBottom: '10px' }} color='primary'>
                Alcoholimetría
            </Typography>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', paddingLeft: '23%', marginRight: '20%' }}>
                <ApexCharts options={options} series={options.series} type="radialBar" height={240} />
                <List style={{ textAlign: 'center' }}>
                    <ListItem>
                        <ListItemIcon>
                            <FiberManualRecordIcon style={{ color: colores[0], marginLeft: '-15%' }} />
                        </ListItemIcon>
                        <ListItemText primary={`Negativos: ${negativos}`} style={{ marginLeft: '-15%', marginTop: '-3%' }} />
                    </ListItem>
                    <ListItem>
                        <ListItemIcon>
                            <FiberManualRecordIcon style={{ color: colores[1], marginLeft: '-15%', marginTop: '-40%' }} />
                        </ListItemIcon>
                        <ListItemText primary={`Positivos: ${positivos}`} style={{ marginLeft: '-15%', marginTop: '-11%' }} />
                    </ListItem>
                    <ListItem>
                        <span style={{ fontSize: '32px', fontWeight: 'bold', marginTop: '-5%', paddingRight: '10px' }}>{total}</span>
                        <span style={{ fontSize: '17px', marginBottom: '-5%', marginTop: '-5%' }}>{totalPositivos}</span>
                    </ListItem>
                </List>
            </div>
        </>
    );
}

export default GraficaAlcohol;
